import React from 'react'
import AnalyticsChartSkeleton from './AnalyticsChartSkeleton'
import BarChartSkeleton, { BarChartHeaderSkeleton } from './BarChartSkeleton'
import GenderBarChartSkeleton from './GenderBarChartSkeleton'

const AnalyticsDataContainerSkeleton = () => {
    return (
        <div className="w-full bg-white rounded-[10px] p-[35px] mt-[30px] mb-12 animate-pulse">
            {/* Header */}
            <div className="flex flex-row items-center justify-between mb-6">
                <div className="flex flex-row items-center gap-[13px]">
                    <div className="min-w-[46px] h-[46px] bg-lightBG rounded-full"></div>
                </div>
                <div className="h-8 w-[320px] bg-lightBG rounded opacity-50"></div>
                <div className="ml-14"></div>
            </div>
            <div className="h-[1px] bg-lightBG mt-[23px] mb-[20px]"></div>

            {/* Line Chart Skeleton */}
            <AnalyticsChartSkeleton />

            {/* Bar Chart Section */}
            <div className="w-full mt-[50px]">
                <BarChartHeaderSkeleton />
                <BarChartSkeleton />
            </div>

            {/* Gender Bar Chart Section */}
            <div className="flex flex-row items-center justify-between mt-[20px]">
                <div className="flex flex-row items-center gap-5">
                    <div className="h-6 w-[120px] bg-lightBG rounded opacity-50"></div>
                    <div className="h-4 w-[80px] bg-lightBG rounded opacity-30"></div>
                    <div className="h-4 w-[80px] bg-lightBG rounded opacity-30"></div>
                </div>
                <div className="h-4 w-[220px] bg-lightBG rounded opacity-30"></div>
            </div>
            <GenderBarChartSkeleton />

            {/* Feedback Section (only for feedback type) */}
            <div className="w-full">
                <div className="flex flex-row items-center justify-between mt-[30px] mb-[35px]">
                    <div className="h-6 w-[180px] bg-lightBG rounded opacity-50"></div>
                    <div className="h-4 w-[220px] bg-lightBG rounded opacity-30"></div>
                </div>
                <div className="flex flex-row justify-between h-[551px]">
                    {/* Donut Chart & Stats */}
                    <div className="w-[379px] flex flex-col items-center justify-center bg-lightBG p-[24px] rounded-[15px] mr-[15px]">
                        <div className="h-[314px] w-[314px] bg-white rounded-full mb-6"></div>
                        <div className="h-[75px] w-full bg-white rounded-[10px] mb-4 flex items-center px-6">
                            <div className="h-[50px] w-[50px] bg-lightBG rounded-full"></div>
                        </div>
                        <div className="h-[75px] w-full bg-white rounded-[10px] flex items-center px-6">
                            <div className="h-[50px] w-[50px] bg-lightBG rounded-full"></div>
                        </div>
                    </div>
                    {/* Pie Chart Table */}
                    <div className="w-[722px] bg-lightBG rounded-[10px] p-5 flex flex-col gap-2">
                        <div className="flex items-center justify-between px-5">
                            <div className="h-6 w-[120px] bg-white rounded opacity-50"></div>
                            <div className="h-6 w-[120px] bg-white rounded opacity-50"></div>
                            <div className="h-6 w-[60px] bg-white rounded opacity-50"></div>
                        </div>
                        {[...Array(6)].map((_, idx) => (
                            <div key={idx} className="flex flex-row justify-between items-center gap-4 px-5 mb-[6px] h-10 rounded-full bg-white">
                                <div className="flex flex-row items-center gap-2">
                                    <div className="h-8 w-8 bg-lightBG rounded-full"></div>
                                    <div className="h-4 w-[80px] bg-lightBG rounded"></div>
                                </div>
                                <div className="h-4 w-[80px] bg-lightBG rounded"></div>
                                <div className="h-4 w-[50px] bg-lightBG rounded"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsDataContainerSkeleton
